/** Browser-safe e-invoice helpers (no qrcode/xlsx — safe for @react-pdf preview). */

export function formatAckDateDisplay(raw) {
  if (raw == null || raw === "") return "";
  const s = String(raw).trim();
  if (!s) return "";
  if (s.includes("T")) {
    const d = new Date(s);
    if (!Number.isNaN(d.getTime())) {
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    }
    return s
      .replace("T", " ")
      .replace(/\.\d{3}Z?$/i, "")
      .replace(/Z$/i, "");
  }
  return s;
}

export function resolveSaleEinvoiceFields(source = {}) {
  const portal =
    source.gst_portal && typeof source.gst_portal === "object"
      ? source.gst_portal
      : source.gstPortal && typeof source.gstPortal === "object"
        ? source.gstPortal
        : null;

  const signed_qr_code = String(
    portal?.signed_qr_code ??
      portal?.signed_qr ??
      source.signed_qr_code ??
      source.signed_qr ??
      source.signedQrCode ??
      "",
  ).trim();
  const irn = String(portal?.irn ?? source.irn ?? "").trim();
  const ack_no = String(
    portal?.ack_no ?? portal?.ackNo ?? source.ack_no ?? source.ackNo ?? "",
  ).trim();
  const ack_date_raw = String(
    portal?.ack_date ?? portal?.ackDate ?? source.ack_date ?? source.ackDate ?? "",
  ).trim();

  return {
    irn,
    ack_no,
    ack_date: formatAckDateDisplay(ack_date_raw),
    signed_qr_code,
    portal_status: String(
      portal?.portal_status ??
        portal?.einvoice_status ??
        source.portal_status ??
        source.einvoice_status ??
        "",
    ).trim(),
    gst_portal: portal,
  };
}

/** Load qrcode lazily so Node fs is never pulled into the PDF preview bundle. */
export async function buildSignedQrDataUrl(payload) {
  const text = String(payload || "").trim();
  if (!text) return "";
  const mod = await import("qrcode");
  const toDataURL = mod.toDataURL || mod.default?.toDataURL;
  if (typeof toDataURL !== "function") {
    throw new Error("qrcode.toDataURL is unavailable");
  }
  return toDataURL(text, {
    margin: 0,
    width: 240,
    errorCorrectionLevel: "L",
  });
}

/** @deprecated Use data:image/png;base64,... string as react-pdf Image src. */
export function dataUrlToPdfImageSource(dataUrl) {
  return String(dataUrl || "").trim() || null;
}
